@if (spinner) {
<app-spinner></app-spinner>
}
<div class="inner-page-header" #goUp>
  <h3>{{ pageTitle }}</h3>
</div>
<div class="request-control">
  <div class="right-side">
    @if (filterData) {
    <app-filter [filterData]="filterData" [filterDataInit]="filterDataInit" [filterPage]="filterPage"
      (formValus)="filterFormValues($event)">
    </app-filter>
    }
    <quick-search [placeholder]="' البحث باسم الخبير، البريد الإلكتروني، أو الرقم التعريفي ...  '"
      (searchResults)="quickSearch($event)"></quick-search>
  </div>
</div>
<div class="saved-filters">
  <saved-filters></saved-filters>
</div>
@if (inspectors?.length > 0) {
<div class="request-table">
  <div class="table-responsive">
    <table mat-table class="mat-elevation-z8 no-shadow table-profiles"
      [dataSource]="inspectors | paginate: config ">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>الأسم</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="internal_id">
        <th mat-header-cell *matHeaderCellDef>الرقم التعريفي</th>
        <td mat-cell *matCellDef="let row">
          <span class="link-cell" (click)="goToProfile(row.user_id)">{{ row.internal_id }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="profile_views">
        <th mat-header-cell *matHeaderCellDef class="sortable-header" (click)="toggleSort('profile_views')">
          زيارات الملف الشخصي
          <img [src]="getSortImg('profile_views')" alt="ترتيب" class="sort-icon" />
        </th>
        <td mat-cell *matCellDef="let row">{{ row.profile_views }}</td>
      </ng-container>

      <ng-container matColumnDef="utm_source">
        <th mat-header-cell *matHeaderCellDef>مصدر الخبير</th>
        <td mat-cell *matCellDef="let row">{{ row.utm_source || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>البريد الاكترونى</th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ expertConfig.statusLabel }}</th>
        <td mat-cell *matCellDef="let row">
          <span class="bold" [ngClass]="{
          'text-green': row.status?.id === 'ACCEPTED',
          'text-danger': row.status?.id === 'REJECTED',
          'text-warning': row.status?.id === 'PENDING' || row.status?.id === 'REVISION_NEEDED',
          'text-grey': row.status?.id === 'UNDER_REVIEW'
        }">
            {{ row.status?.name }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>سبب الرفض</th>
        <td mat-cell *matCellDef="let row" class="notes-cell">
          <ng-container>
            @if (row.status?.id === 'REJECTED') {
            <span [innerHTML]="getDecodedNotes(row.notes)"></span>
            }
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef> تاريخ التقديم </th>
        <td mat-cell *matCellDef="let row">{{ row.created_at }}</td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef> تاريخ الموافقة </th>
        <td mat-cell *matCellDef="let row">{{ row.updated_at}}</td>
      </ng-container>

      @if (expertConfig.expertType === 'sopra') {
      <ng-container matColumnDef="share_type">
        <th mat-header-cell *matHeaderCellDef>نوع حصة الفاحص </th>
        <td mat-cell *matCellDef="let row">
          <ng-select
            bindLabel="name" class="single-select" placeholder="نوع حصة الفاحص"
            appendTo="body" (change)="onRoleChange(row, $event)" [ngModel]="row.share_type?.id">
            @for (option of inspectorShareTypes; track option) {
            <ng-option [value]="option.id">
              {{ option.name }}
            </ng-option>
            }
          </ng-select>
        </td>
      </ng-container>
      }

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>تنفيذ الأمر</th>
        <td mat-cell *matCellDef="let row" class="actions">
          <button mat-button class="text-green" color="primary" (click)="acceptRequest(row)"
            [disabled]="row.status?.id === exsepProfile.Accepted">
            قبول
          </button>
          <button mat-button class="text-danger" color="warn" (click)="rejectRequest(row)"
            [disabled]="row.status?.id === exsepProfile.Accepted">
            رفض
          </button>
          <button mat-button class="text-warning" color="warn" (click)="RequireData(row)"
            [disabled]="row.status?.id === exsepProfile.Accepted">
            تعديل مطلوب
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
} @if (inspectors && inspectors?.length > 0) {
<ayen-pagination (pageData)="pageChanged($event)" (pageSize)="pageSizeChanged($event)" [totalCount]="config.totalItems"
  [pageTitle]="pageTitle" [itemsPerPage]="config.itemsPerPage" [currentPage]="config.currentPage"
  (pageChange)="changeToSpecific($event)">
</ayen-pagination>
}
